module.exports = __webpack_public_path__ + "static/media/game-background-interfaces.7f034f78.jpg";